import { CognitoUser } from '@aws-amplify/auth'

export const MODULE_NAME = 'AUTH'

// Mutations
export const SET_USER = 'SET_USER'
// Actions
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const FETCH_USER_DATA = 'FETCH_USER_DATA'
export const FETCH_ROUTE_PERMISSIONS = 'FETCH_ROUTE_PERMISSIONS'
export const CHECK_LOGGED_IN = 'CHECK_LOGGED_IN'
// Getters
export const GET_USER = 'GET_USER'
export const GET_USER_NAME = 'GET_USER_NAME'
export const GET_USER_EMAIL = 'GET_USER_EMAIL'
export const GET_USER_GROUPS = 'GET_USER_GROUPS'

export interface AuthState {
  user: null | CognitoUser | any
}

export interface SetUserPayload {
  user: null | CognitoUser | any
}

export interface LoginPayload {
  username: string
  password: string
}

export interface FetchRoutePermissionsResult {
  routes: RoutePermission[]
}

export interface RoutePermission {
  name: string
  path: string
}
